/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-danger */
import DOMPurify from 'dompurify';
import React from 'react';
import { cn } from '@/lib/utils';

interface HtmlViewerProps {
    html: string;
    className?: string;
}

const HtmlViewer = ({ html, className }: HtmlViewerProps): React.JSX.Element => {
    return (
        <div
            className={cn('text-base leading-relaxed [&_img]:max-w-full', className)}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
        />
    );
};

export default HtmlViewer;
